<template>
<div class="login-container  ">
    <img src="/static/logo.jpeg" alt="ITM IHM"  width="170">
    <p style="margin-top:20px"><b>ITM IHM Online Mock JEE Exam Result</b></p><br>
    <div class="card">
        <div class="card-content">
            <b-field label="Email">
                <b-input type="email"  v-model="email"></b-input>
            </b-field>
            <b-field label="Password">
                <b-input type="password" v-model="password"></b-input>
            </b-field>
            <!-- <p class="has-text-danger">{{error}}</p> -->
            <button class="button is-primary full-width-button" style=" width: 100%;  color:white" :class="{'is-loading': isLoading}" @click="login">Login</button>
        </div>
    </div>
</div>
<!-- <div class="login-container">
    <div class="card" style="width:30%">
        <div class="card-content">
            <div class="has-text-centered">
                <img src="/static/logo.png" alt="Logo" width="150">
                <div class="title is-size-5 has-text-centered" style="margin-top:7%">ITM IHM Entrance Exam Reuslt</div>
            </div>

            <b-field type="is-primary" style="margin-top:10%" label="Email">
                <b-input type="email" placeholder="abc@gmail.com" v-model="email"></b-input>
            </b-field>
            <b-field type="is-primary" label="Password">
                <b-input type="password" placeholder="123456" v-model="password"></b-input>
            </b-field>
            <b-button style="margin-top:5%" type="is-primary" expanded @click="login"> <strong>VALIDATE</strong> </b-button>

            <div class="subtitle has-text-centered is-size-7" style="margin-top:10px">
                <b>2020 © LetsUpgrade</b>
            </div>
        </div>
    </div>
</div> -->
</template>

<script>
import Firebase from '../../lib/Firebase';
import Firestore from "../../lib/Firestore";
import dashboardService from './service.js'
import Vue2Filters from 'vue2-filters';

export default {
    name: "dashboard",
    mixins: [Vue2Filters.mixin],
    components: {

    },
    data() {
        return {

            email: '',
            password: '',
            resultData: null
        }
    },
    computed: {

    },
    created() {

    },
    mounted() {
        // console.log(this.finishBtn)
    },
    computed() {
        //  console.log(this.finishBtn)
    },
    methods: {
        isMobile() {
            if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                return true
            } else {
                return false
            }
        },
        login() {

            Firebase.firestore()
                .collection('report')
                .where('email', '==', this.email)
                .where('password', '==', this.password)
                .get()
                .then((docs) => {
                    this.resultData = Firestore.getCollectionData(docs)

                    if (this.resultData.length <= 0) {
                        alert('Wrong Email or Password!')
                    } else {
                        // console.table(this.resultData)
                        this.$emit('REPORT', this.resultData[0])
                        var docId1 = this.resultData[0].docId
                        this.$router.push({
                            name: 'result',
                            params: {
                                docId: docId1
                            }
                        })
                        // this.$router.push("/result");

                    }
                });

        }
    }
}
</script>

<style scoped>
.login-container {
    background-color: #ffffff;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.card{
        width: 300px;
}
.button {
    width: 100%;
    color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/pages/dashboard/Dashboard.vue